// extracted by mini-css-extract-plugin
module.exports = {"loadingContain":"cluster-detail_loadingContain__2qjm9","iframediv":"cluster-detail_iframediv__3-rj6"};